import { apiGetRequest } from "helpers/Requests";
import { URL_ROSTERING_GET_NDIS_LINE_ITEMS_ON_SCHEDULING_SHIFT } from "store/services/URL";

const cache = new Map();
const inFlight = new Map();

export function buildShiftNdisItemsUrl({
  serviceTypeId,
  participantId,
  formattedShiftDate,
}) {
  return `${URL_ROSTERING_GET_NDIS_LINE_ITEMS_ON_SCHEDULING_SHIFT}?invoice_service_type_id=${serviceTypeId}&pt_id=${participantId}&shift_date=${formattedShiftDate}`;
}

export function fetchShiftNdisItems(url) {
  if (cache.has(url)) {
    return Promise.resolve(cache.get(url));
  }
  if (inFlight.has(url)) {
    return inFlight.get(url);
  }

  const promise = apiGetRequest(url)
    .then((res) => {
      const items = res?.data?.data?.items ?? [];
      cache.set(url, items);
      inFlight.delete(url);
      return items;
    })
    .catch((err) => {
      inFlight.delete(url);
      throw err;
    });

  inFlight.set(url, promise);
  return promise;
}

export function mapShiftNdisItemsToOptions(items) {
  return (items ?? []).map((item) => {
    const isCustom = Boolean(item?.is_custom || item?.custom_line_item_uuid);
    const code = item?.support_item_number || "";
    const name = item?.support_item_name || "";
    const uuid = item?.custom_line_item_uuid || null;
    const display = isCustom
      ? [code, name].filter(Boolean).join(" ")
      : name;
    return {
      label: display,
      value: isCustom ? uuid : item?.id,
      number: code,
      name: display || name,
      price: item?.price,
      is_custom: isCustom,
      uuid,
      funding_type: item?.funding_type || null,
      invoice_service_type_id: item?.invoice_service_type_id ?? null,
      __type: isCustom ? "custom" : "ndis",
    };
  });
}

export function clearShiftNdisItemsCache() {
  cache.clear();
  inFlight.clear();
}
